export default __webpack_public_path__ + "static/media/settings_icon.21c4a317.svg";